//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from '../components/layout/Header.vue'
import HeaderLasa from '../components/layout/HeaderLasa.vue'
import Footer from '../components/layout/Footer.vue'
import FooterLasa from '../components/layout/FooterLasa.vue'
import portal from '~/net/portal'
import Courier from '~/components/Courier'
import HeaderCollege from '../components/layout/HeaderCollege.vue'
import FooterCollege from '../components/layout/FooterCollege.vue'
import HeaderMeterage from '../components/layout/HeaderMeterage.vue'
import FooterMeterage from '../components/al-overallFooter.vue'



export default {
    head() {
        return {
            title: '江苏省技术产权交易市场-专利技术转让-专利交易发布-知识产权申请平台',
            meta: [
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: '专利转让,技术转让,专利交易,知识产权,知识产权申请,江苏省技术产权交易市场'
                },
                {
                    hid: 'description',
                    name: 'description',
                    content: '江苏省技术产权交易市场平台，专注专利转让、技术转让、专利交易、知识产权、知识产权申请，包括发明技术成果、实用新型专利、知识产权服务、电子信息、生物与新医药、航空航天、新材料、高技术服务、新能源与节能资源与环境、先进制造与自动化等服务。'
                }
            ]
        }
    },
    middleware: 'appData',
    components: {
        Courier,
        Header,
        HeaderLasa,
        FooterLasa,
        Footer,
        HeaderCollege, FooterCollege,
        HeaderMeterage, FooterMeterage
    },
    data() {
        return {
            showRightWidow: true,
            navigationType: '',
            headerType: '',
            footerType: ''
        }
    },
    mounted() {
        this.navigationType = localStorage.getItem('navigationType')
        if (this.navigationType == 'lasa') {
            this.headerType = 'HeaderLasa'
            this.footerType = 'FooterLasa'
            document.title = '拉萨市技术产权交易网-专利技术转让-专利交易发布-知识产权申请平台'
        } else if (this.navigationType == 'gaoxiao') {
            this.headerType = 'HeaderCollege'
            this.footerType = 'FooterCollege'
            document.title = '全国高校区域技术转移转化中心（江苏）一体化平台'
        } else if (this.navigationType == 'jiliang') {
            this.headerType = 'HeaderMeterage'
            this.footerType = 'FooterMeterage'
            document.title = '现代先进测量体系服务平台'
        } else {
            this.headerType = 'Header'
            this.footerType = 'Footer'
            document.title = '江苏省技术产权交易市场-专利技术转让-专利交易发布-知识产权申请平台'
        }
        if (
            this.$router.currentRoute.path.includes('/achievement') ||
            this.$router.currentRoute.path.includes('/Intermediary') ||
            this.$router.currentRoute.path.includes('/demandDashboard/dashboard') ||
            this.$router.currentRoute.path.includes('/demandDashboard') ||
            this.$router.currentRoute.path.includes('/roadShow') ||
            this.$router.currentRoute.path.includes('/overall') ||
            this.$router.currentRoute.path.includes('/lasa')
        ) {
            this.showRightWidow = false
        }
        
        this.queryHis()
        this.$bus.$on('changeBar', this.changeBar)
    },
    methods: {
        changeBar(type) {
            if (type == 'lasa') {
                this.navigationType = 'lasa'
                localStorage.setItem('navigationType', 'lasa')
                this.headerType = 'HeaderLasa'
                this.footerType = 'FooterLasa'
                document.title = '拉萨市技术产权交易网-专利技术转让-专利交易发布-知识产权申请平台'
            } else if (type == 'gaoxiao') {
                this.navigationType = 'gaoxiao'
                localStorage.setItem('navigationType', 'gaoxiao')
                this.headerType = 'HeaderCollege'
                this.footerType = 'FooterCollege'
                document.title = '全国高校区域技术转移转化中心（江苏）一体化平台'
            } else if (type == 'jiliang') {
                this.navigationType = 'jiliang'
                localStorage.setItem('navigationType', 'jiliang')
                this.headerType = 'HeaderMeterage'
                this.footerType = ''
                document.title = '现代先进测量体系服务平台'
            }
            this.queryHis()
        },
        async queryHis() {
            const strCookie = document.cookie
            const cookies = strCookie.split(' ')
            let touristId = ''
            cookies.map(str => {
                if (str.includes('NW_TOURIST_ID')) {
                    const tempArr = str.split('=')
                    touristId = tempArr[1]

                    if (touristId.indexOf(';') > 0) {
                        touristId = touristId.substring(0, touristId.length - 1)
                    }
                    localStorage.setItem('TOURIST_ID', touristId)
                }
            })

            const { code, data } = await portal.selectHomePageActivityId({
                body: {
                    touristId
                }
            })

            if (code == '0000') {
                if (data == '202410602943614795') {
                    // 切换拉萨导航栏
                    this.navigationType = 'lasa'
                    localStorage.setItem('navigationType', 'lasa')
                    this.headerType = 'HeaderLasa'
                    this.footerType = 'FooterLasa'
                    document.title = '拉萨市技术产权交易网-专利技术转让-专利交易发布-知识产权申请平台'
                } else if (data == '202428303021097797') {
                    this.navigationType = 'gaoxiao'
                    localStorage.setItem('navigationType', 'gaoxiao')
                    this.headerType = 'HeaderCollege'
                    this.footerType = 'FooterCollege'
                    document.title = '全国高校区域技术转移转化中心（江苏）一体化平台'
                } else if (data == '202413602956578655') {
                    this.navigationType = 'jiliang'
                    localStorage.setItem('navigationType', 'jiliang')
                    this.headerType = 'HeaderMeterage'
                    this.footerType = 'FooterMeterage'
                    document.title = '现代先进测量体系服务平台'
                } else {
                    console.log('返回省平台')
                    this.navigationType = ''
                    localStorage.setItem('navigationType', '')
                    this.headerType = 'Header'
                    this.footerType = 'Footer'
                    document.title = '江苏省技术产权交易市场-专利技术转让-专利交易发布-知识产权申请平台'
                }
            }
        }
    }
}
